import {Base} from "@/api/Base"

export class LeaveGetTotalSickLeaveDays extends Base {
    path = "leave/getTotalSickLeaveDays"
}